import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { Provider } from 'react-redux';
import AppRouter from '@/router';
import GlobalErrorBoundary from '@/providers/GlobalErrorBoundary';
import { store } from '@/store';
import { appTheme } from '@/theme';

const AppProviders = () => (
  <Provider store={store}>
    <ConfigProvider locale={zhCN} theme={appTheme}>
      <AntdApp>
        <GlobalErrorBoundary>
          <AppRouter />
        </GlobalErrorBoundary>
      </AntdApp>
    </ConfigProvider>
  </Provider>
);

export default AppProviders;
